import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { RequestOpeningTemplateService } from './service/request-opening-template.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-request-opening-template',
	templateUrl: './request-opening-template.component.html',
	styleUrls: ['./request-opening-template.component.scss'],
})
export class RequestOpeningTemplateComponent implements OnInit {
	icons = {
		faInfoCircle: faInfoCircle,
	};

	labels: LabelsInterface = {
		lbl_geral_buscar: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_geral_deletado_com_sucesso: '',
		lbl_kb_criar: '',
		lbl_geral_atualizar: '',
		lbl_geral_excluir: '',
		lbl_chat_limpar: '',
		lbl_clique_confirmar_acao: '',
		lbl_geral_nome: '',
		lbl_geral_summary: '',
		lbl_geral_descricao: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_classificacao: '',
		lbl_template_abertura_chamado: '',
		lbl_geral_voltar: '',
		lbl_geral_informativo: '',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_geral_descricao_justificativa_obrigatoria: '',
		lbl_geral_chamado_confidencial: '',
		lbl_geral_tipo_de_risco: '',
		lbl_geral_id_template: '',
		lbl_geral_explicacao_id_template: '',
	};

	searchHeader: mspTableHeaderI[] = [{ name: 'name', value: 'lbl_template_abertura_chamado', colType: 'text' }];

	classificationOptions = {
		isEditingClassification: true,
		disabled: false,
		selectedCustomer: null,
		lockField: [],
		hideField: ['impact', 'urgency', 'severity'],
		alertField: [],
		initOn: 'topic',
		thisAnalystOnly: false,
		hideServiceType: [],
	};

	classificationIds = {};

	editorConfig: AngularEditorConfig = {
		editable: true,
		translate: 'no',
		outline: false,
		toolbarHiddenButtons: [
			[
				'undo',
				'redo',
				// 'bold',
				// 'italic',
				// 'underline',
				'strikeThrough',
				'subscript',
				'superscript',
				'justifyLeft',
				'justifyCenter',
				'justifyRight',
				'justifyFull',
				'indent',
				'outdent',
				'insertUnorderedList',
				'insertOrderedList',
				'heading',
				'fontName',
			],
			[
				'fontSize',
				// 'textColor',
				'backgroundColor',
				'customClasses',
				// 'link',
				// 'unlink',
				'insertImage',
				'insertVideo',
				'insertHorizontalRule',
				'removeFormat',
				'toggleEditorMode',
			],
		],
	};

	constructor(
		private RequestOpeningTemplateService: RequestOpeningTemplateService,
		private NotificationService: NotificationService,
		private LabelsService: LabelsService
	) {}

	isLoadingTemplates = true;
	isLoadingLabels = true;
	isUpdatingTemplate = false;

	availableTemplates: templateReworkInterface[] = [];
	availableTemplatesIAC: iacOptionInterface[] = [];
	availableTemplateDictionary = {};

	selectedTemplate: templateReworkInterface = {
		id: undefined,
		name: '',
		summary: '',
		description: '',
		informative: '',
		service_type: undefined,
		scope: undefined,
		category: undefined,
		topic: undefined,
		solution_area: undefined,
		severity: undefined,
		description_required: false,
		confidential_request: false,
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.RequestOpeningTemplateService.getAvailableTemplates().subscribe((templates) => {
			this.availableTemplates = templates;
			for (const template of this.availableTemplates) {
				this.availableTemplateDictionary[template.id] = template;
				const newIAC: iacOptionInterface = {
					name: template.name,
					value: template.id,
				};

				this.availableTemplatesIAC.push(newIAC);
			}
			this.isLoadingTemplates = false;
		});
	}

	setTemplate(idTemplate: number): void {
		this.resetSelectedTemplate();
		setTimeout(() => {
			this.selectedTemplate = this.availableTemplateDictionary[idTemplate];

			const temporaryClassificationIds: any = {};
			temporaryClassificationIds.idSolutionArea = this.selectedTemplate.solution_area.toString();
			temporaryClassificationIds.idServiceType = this.selectedTemplate.service_type.toString();
			temporaryClassificationIds.idScope = this.selectedTemplate.scope.toString();
			temporaryClassificationIds.idCategory = this.selectedTemplate.category.toString();
			temporaryClassificationIds.idTopic = this.selectedTemplate.topic.toString();
			temporaryClassificationIds.idImpact = null;
			temporaryClassificationIds.idUrgency = null;
			temporaryClassificationIds.idSeverity = this.selectedTemplate.severity.toString();
			this.classificationIds = temporaryClassificationIds;
		}, 50);
	}

	resetSelectedTemplate(isNew?: boolean): void {
		this.isLoadingTemplates = true;
		setTimeout(() => {
			this.selectedTemplate = {
				id: isNew ? '0' : undefined,
				name: '',
				summary: '',
				description: '',
				informative: '',
				service_type: undefined,
				scope: undefined,
				category: undefined,
				topic: undefined,
				solution_area: undefined,
				severity: undefined,
				description_required: false,
				confidential_request: false,
			};
			this.isLoadingTemplates = false;
		}, 50);
	}

	setClassification(classificationString): void {
		const classification = JSON.parse(classificationString);
		if (classification.serviceType[0]?.id) this.selectedTemplate.service_type = classification.serviceType[0].id;
		if (classification.scope[0]?.id) this.selectedTemplate.scope = classification.scope[0].id;
		if (classification.category[0]?.id) this.selectedTemplate.category = classification.category[0].id;
		if (classification.topic[0]?.id) this.selectedTemplate.topic = classification.topic[0].id;
		if (classification.solutionArea[0]?.id) this.selectedTemplate.solution_area = classification.solutionArea[0].id;
	}

	isFormFulfilled(): boolean {
		if (
			this.selectedTemplate.name.trim() == '' ||
			this.selectedTemplate.summary.trim() == '' ||
			this.selectedTemplate.topic == undefined ||
			this.selectedTemplate.solution_area == undefined
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return false;
		}

		return true;
	}

	createTemplate(): void {
		if (!this.isFormFulfilled() || this.isUpdatingTemplate) return;

		this.isUpdatingTemplate = true;
		this.RequestOpeningTemplateService.createTemplate(this.selectedTemplate).subscribe(
			(res) => {
				this.selectedTemplate.id = res.id;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.isUpdatingTemplate = false;
			},
			() => {
				this.isUpdatingTemplate = false;
			}
		);
	}

	updateTemplate(): void {
		if (!this.isFormFulfilled() || this.isUpdatingTemplate) return;

		this.isUpdatingTemplate = true;
		this.RequestOpeningTemplateService.updateTemplate(this.selectedTemplate).subscribe(
			(res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingTemplate = false;
			},
			() => {
				this.isUpdatingTemplate = false;
			}
		);
	}

	deleteTemplate(): void {
		if (this.isUpdatingTemplate) return;

		this.isUpdatingTemplate = true;
		this.RequestOpeningTemplateService.deleteTemplate(this.selectedTemplate.id).subscribe(
			(res) => {
				this.resetSelectedTemplate();
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
				this.isUpdatingTemplate = false;
			},
			() => {
				this.isUpdatingTemplate = false;
			}
		);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}
}
